import api from "api";

export const getSessionApi = (currentStartDate, currentEndDate, prevStartDate, prevEndDate) => {
    return api.get(`customer-session-dashboard?currentStartDate=${currentStartDate}&currentEndDate=${currentEndDate}&previousStartDate=${prevStartDate}&previousEndDate=${prevEndDate}`);
};

export const getAovApi = (currentStartDate, currentEndDate, prevStartDate, prevEndDate) => {
    return api.get(`customer-aov-dashboard?currentStartDate=${currentStartDate}&currentEndDate=${currentEndDate}&previousStartDate=${prevStartDate}&previousEndDate=${prevEndDate}`);
};

export const getConversionApi = (currentStartDate, currentEndDate, prevStartDate, prevEndDate) => {
    return api.get(`customer-conversion-dashboard?currentStartDate=${currentStartDate}&currentEndDate=${currentEndDate}&previousStartDate=${prevStartDate}&previousEndDate=${prevEndDate}`);
};